<template>
  <!-- 出库弹窗 -->
  <div>
    <BaseDialog
      title="商品调价"
      @handleShow="
        (val) => {
          visible = val
        }
      "
      :isshow="visible"
      width="800px"
      height="auto"
    >
      <div class="tables adjustTable">
        <el-table
          size="small"
          v-loading="dataListLoading"
          :data="tableData"
          stripe
          border
        >
          <el-table-column
            prop="drug.name"
            label="商品名称"
            show-overflow-tooltip
          >
          </el-table-column>
          <!-- <el-table-column
            width="120"
            show-overflow-tooltip
            prop="drug.medi_spec"
            label="规格"
          />
          <el-table-column
            width="180"
            show-overflow-tooltip
            prop="drug.company"
            label="生产厂家"
          /> -->
          <el-table-column
            width="100"
            prop="before_price"
            label="调前价格"
          >
          </el-table-column>
          <el-table-column
            width="100"
            prop="after_price"
            label="调后价格"
          >
          </el-table-column>
          <el-table-column
            width="90"
            align="center"
            prop="drug.dict_first_unit_name"
            label="零售单位"
          />
          <el-table-column width="90" align="center" prop="operator" label="操作人" />
          <el-table-column
            prop="created_time"
            label="调价时间"
            width="180"
            align="center"
          >
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-box">
        <el-pagination
          v-model:currentPage="pageData.current"
          v-model:page-size="pageData.size"
          :page-sizes="[10, 20, 50, 100]"
          :background="true"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageData.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </BaseDialog>
  </div>
</template>

<script>
import { toRefs, reactive, getCurrentInstance } from 'vue'
import service from '@/utils/request'
import BaseDialog from '@/components/Dialog/index.vue'
export default {
  components: {
    BaseDialog,
  },
  props: {
    dictCatalogType: {
      type: String,
      default: '',
    },
  },
  setup(props, ctx) {
    let proxy = getCurrentInstance()
    const state = reactive({
      visible: false,
      dataListLoading: false,
      tableData: null,
      pageData: {
        enter_record_id: 0,
        current: 1,
        size: 10,
        total: 0,
      },
    })
    const initData = async (row) => {
      state.pageData.enter_record_id = row.id
      state.visible = true
      getList()
    }
    const getList = async () => {
      let url = '/api/store_enter_record/adjustRecord'
      let res = await service.post(url, state.pageData)
      if (res.code == 0) {
        state.pageData.total = res.data.total
        state.tableData = res.data.list
      }
    }
    const handleSizeChange = async (e) => {
      state.pageData.size = e
      getList()
    }
    const handleCurrentChange = async (e) => {
      state.pageData.current = e
      getList()
    }
    return {
      ...toRefs(state),
      initData,
      getList,
      handleSizeChange,
      handleCurrentChange,
    }
  },
}
</script>
<style scoped lang="scss">
  .adjustTable {
    margin-top: 10px;
  }
</style>